import { NgElement, WithProperties } from '@angular/elements';
import { environment } from 'environments/environment';

export { ChatWidgetComponent } from './chat-widget/chat-widget.component'
export { ChatModule } from './chat.module'

const WIDGET_TAG_NAME = 'chat-widget';

const FONTES = [
  'https://fonts.googleapis.com/css?family=Material+Icons|Material+Icons+Outlined|Material+Icons+Two+Tone|Material+Icons+Round|Material+Icons+Sharp',  
  'https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap'
];

function carregarFontes() {
  FONTES.forEach((href) => {
    if (document.head.querySelector(`link[href="${href}"]`) != null) {
      return;
    }
    const link = document.createElement('link');
    link.type = 'text/css';
    link.rel = 'stylesheet';
    link.href = href;
    document.head.appendChild(link);
  });
}

carregarFontes();

if (environment.production
    && document.getElementsByTagName(WIDGET_TAG_NAME).length === 0
    && window.location.pathname !== '/fullscreen') {

  customElements.whenDefined(WIDGET_TAG_NAME).then(() => {
    const popupEl = document.createElement(WIDGET_TAG_NAME) as HTMLElement & {
      addEventListener: (type: string, listener: EventListenerOrEventListenerObject) => void;
    };

    popupEl.addEventListener('closed', () => {
      document.body.removeChild(popupEl);
    });

    document.body.appendChild(popupEl);
  });
}
